import React from 'react'
import dynamic from 'next/dynamic'

import {LazyLoad} from '@lib/LazyLoad'
import Meta from '@components/Meta'

const MainLayout = dynamic(() => import('@components/MainLayout'))
const GetStarted = dynamic(() => import('@components/GetStarted'))

export default function TermsOfUse() {
  return (
    <React.Fragment>
      <Meta title='Terms of Use – Data Science Consultant Thailand | Data Wow in Bangkok' />

      <div className='Document'>
        <div className='Document__hero'>
          <div className='container'>
            <h1>ข้อตกลงการใช้งาน</h1>
            <p>
              ข้อตกลงการใช้งานเหล่านี้ บังคับใช้กับ{' '}
              <a href='https://www.datawow.co.th'>https://www.datawow.co.th</a>{' '}
              ("เว็บไซต์") โดยการใช้งานเว็บไซต์นี้
              ท่านตกลงที่จะผูกพันทางกฎหมายกับ บริษัท เดต้า ว้าว จำกัด (“Data
              Wow” “เรา” หรือ “ของเรา”)
              สำหรับวัตถุประสงค์ของข้อกำหนดการใช้งานนี้ “ท่าน” จะหมายถึง
              ผู้ใช้เว็บไซต์ใด ๆ ไม่ว่าท่านจะซื้อสินค้าหรือไม่ก็ตาม
            </p>
          </div>
        </div>

        <div className='Document__divider'></div>

        <div className='Document__content'>
          <div className='container'>
            <h3>1. ข้อกำหนดทั่วไป</h3>
            <p>
              การเข้าถึงและการใช้งานเว็บไซต์และการบริการที่ใช้ได้ผ่านเว็บไซต์นี้
              (เรียกรวมกันว่า "บริการ")
              อยู่ภายใต้ข้อกำหนดเงื่อนไขและประกาศดังต่อไปนี้
              ("ข้อกำหนดการใช้งาน") ในการใช้งานเว็บไซต์นี้
              ท่านได้ทำการยอมรับโดยปราศจากเงื่อนไขในข้อกำหนดการใช้งานเหล่านี้
              ซึ่งเราขอสงวนสิทธิ์ใช้ดุลยพินิจของเราแต่เพียงผู้เดียวในการปรับปรุงหรือแก้ไขข้อกำหนดการใช้งานเหล่านี้
              การใช้งานเว็บไซต์อย่างต่อเนื่องหลังจากการประกาศการเปลี่ยนแปลงเกี่ยวกับข้อกำหนดการใช้งาน
              ให้ถือว่าเป็นการยอมรับการเปลี่ยนแปลงเหล่านั้น
            </p>
            <p>
              ท่านรับประกันและรับรองว่าท่านมีอายุครบ 20 ปีบริบูรณ์
              หรือหากคุณอายุน้อยกว่า 20 ปี ซึ่งบิดามารดา
              หรือผู้ปกครองให้ความยินยอมแล้ว ท่านมีสิทธิตามกฎหมาย
              และมีความสามารถอย่างเต็มที่และมีความสามารถในการเข้าทำสัญญาและปฏิบัติตามข้อกำหนด
              เงื่อนไข ภาระผูกพัน การยืนยัน
              การรับรองและการรับประกันที่กำหนดไว้ในข้อกำหนดการใช้งานนี้
              และเพื่อถือปฏิบัติตามและดำเนินการตามข้อกำหนดการใช้งานเหล่านี้
            </p>

            <h3>2. นโยบายความเป็นส่วนตัว</h3>
            <p>
              นโยบายความเป็นส่วนตัวของเราซึ่งกำหนดวิธีที่เราจะใช้ข้อมูลของท่าน
              โดยสามารถดูได้ที่{' '}
              <a
                href='https://datawow.co.th/policy'
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                https://www.datawow.co.th/policy
              </a>
              ในการใช้งานเว็บไซต์นี้
              ท่านยินยอมให้ดำเนินการตามที่อธิบายไว้ในนั้นและรับประกันว่าข้อมูลทั้งหมดที่ท่านให้นั้นถูกต้อง
            </p>

            <h3>3. ข้อห้าม </h3>
            <p>
              ท่านไม่สามารถใช้งานเว็บไซต์นี้เพื่อวัตถุประสงค์ใด ๆ
              ที่ผิดกฎหมายหรือต้องห้ามตามข้อกำหนดการใช้งานเหล่านี้ หรือ
              จูงใจให้กระทำการใดๆที่ผิดกฎหมายหรือการกระทำใดๆ อันละเมิดสิทธิของ
              Data Wow หรือผู้อื่น
              โดยไม่คำนึงถึงสิทธิอื่นใดหรือข้อจำกัดในข้อกำหนดการใช้งานนี้
              ท่านไม่ได้รับอนุญาตให้ใช้งานเว็บไซต์นี้เพื่อส่งต่อโดยตรงหรือผ่านเว็บไซต์ซึ่งข้อมูล
              ข้อความ เนื้อความ รูปภาพ ไฟล์ ลิงค์หรือซอฟต์แวร์
              ยกเว้นการเชื่อมต่อของท่านที่ได้รับอนุญาตในการใช้งานเว็บไซต์
              หรือในกรณีที่เราขอข้อมูล รวมถึง
              การเข้าสู่เว็บไซต์หรือคอมพิวเตอร์อื่น ๆ หรือ ไวรัสเว็บไซต์
              คอมพิวเตอร์ worms โปรแกรม Trojan horses และ /
              หรือรหัสที่เป็นอันตราย
              และการได้รับการเข้าถึงโดยไม่ได้รับอนุญาตในระบบคอมพิวเตอร์ใดๆ
              และการปลอมตัวเป็นบุคคลอื่น
              รวมถึงแต่ไม่จำกัดเฉพาะผู้ใช้ซึ่งลงทะเบียนใช้งานของเว็บไซต์นี้หรือพนักงานหรือผู้ดูแลระบบของ
              Data Wow
              และการบุกรุกความเป็นส่วนตัวหรือละเมิดสิทธิส่วนบุคคลหรือกรรมสิทธิ์ใด
              ๆ (รวมถึงสิทธิในทรัพย์สินทางปัญญา) ของบุคคลหรือนิติบุคคล รวมทั้ง
              การบิดเบือนตัวตนของผู้ใช้งานหรือใช้ที่อยู่อีเมล์เท็จ
              การแทรกแซงหรือได้รับการเข้าถึงเว็บไซต์นี้หรือส่วนประกอบใด ๆ
              ของเว็บไซต์นี้ และจัดการกิจกรรมซึ่งการฉ้อโกง
              การรวบรวมหรือเก็บเกี่ยวข้อมูลเกี่ยวกับผู้ใช้งานรายอื่นของเว็บไซต์ไม่ว่าด้วยเหตุผลใดก็ตาม
              รวมถึงแต่ไม่จำกัดเฉพาะการส่งอีเมล์เพื่อการค้าที่ไม่พึงประสงค์ให้แก่ผู้ใช้
            </p>

            <h3>4. ทรัพย์สินทางปัญญา </h3>
            <p>
              เนื้อหาบนเว็บไซต์รวมถึง (แต่ไม่จำกัดเพียง) ข้อความ ซอฟต์แวร์
              ต้นฉบับ กราฟิก ภาพถ่าย เสียง เพลง วิดีโอ
              ที่มีคุณสมบัติการทำงานร่วมกัน และสิ่งที่มีลักษณะนี้ (รวมเรียกว่า
              "เนื้อหา") ชุดการค้าของเว็บไซต์และเครื่องหมายการค้า,
              เครื่องหมายบริการ และ เครื่องหมายทั้งหมดใด ๆ
              ที่มีอยู่ภายในเว็บไซต์นั้น (เรียกรวมกันว่า "เครื่องหมาย")
              เป็นกรรมสิทธิ์ของหรือได้อนุญาตให้แก่ Data Wow และ /
              หรือหน่วยงานที่เกี่ยวข้องของ Data Wow
              และอยู่ภายใต้ลิขสิทธิ์และสิทธิทรัพย์สินทางปัญญาอื่น ๆ
              ภายใต้กฎหมายของไทยและกฎหมายต่างประเทศ (foreign law)
              และอนุสัญญาระหว่างประเทศลงนามโดยไทย
            </p>
            <p>
              ไม่มีสิ่งใดในเว็บไซต์ที่อาจตีความได้ว่าเป็นการอนุญาตโดยนัย,
              โดยปิดปากหรือเป็นอย่างอื่น, สิทธิใดๆหรืออนุญาตในการใช้,
              การคัดลอกหรือเลียนแบบเครื่องหมายใด ๆ
              โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรก่อนจากเจ้าของที่เกี่ยวข้อง
              เราขอสงวนสิทธิทั้งหมดไม่อนุญาตอย่างชัดแจ้งในเครื่องหมายนั้น
            </p>

            <h3>5. การลงทะเบียนบัญชี </h3>
            <p>
              ในการลงทะเบียนแต่ละครั้งนั้นเพื่อสำหรับผู้ใช้คนเดียวเท่านั้น
              และในการลงทะเบียนท่านจะต้องระบุชื่อ-นามสกุล,ที่อยู่อีเมล์,วันเกิด
              และตั้งรหัสผ่าน (เรียกรวมกันว่า "ID" ของท่าน)
              การใช้บัญชีที่ลงทะเบียนและ / หรือ ID บนเว็บไซต์
              หรือการเข้าเว็บไซต์ด้วย ID
              เดียวเพื่อผู้ใช้จำนวนหลายคนในเครือข่ายและการใช้ ID
              ของผู้อื่นเป็นสิ่งต้องห้าม ในกรณีที่มีการใช้ ID
              ไม่เหมาะสมหรือไม่ได้รับอนุญาต ทางเราสงวนสิทธิ์ที่จะยกเลิก จำกัด
              หรือระงับ การเป็นสมาชิกและ/หรือการเข้าถึงเว็บไซต์ของท่านด้วย
              (สำหรับช่วงเวลาดังกล่าวและข้อกำหนดดังกล่าว หากมี
              ตามที่เราเห็นสมควรหรือจำเป็น) โดยไม่มีหน้าที่ต้องรับผิดใดๆ Data
              Wow ขอสงวนสิทธิ์ในการปิดบัญชีหากเห็นว่าผู้ใช้รายใดใช้ พร็อกซี IP
              (ที่อยู่ Internet Protocol)
              เพื่อพยายามปิดบังซ่อนเร้นการใช้งานหลายบัญชีหรือการใดๆ
              อันเป็นการขัดขวางบริการ ของเรา
            </p>

            <p>
              ในการลงทะเบียนเพื่อสร้างบัญชีของท่านนั้น
              ท่านรับรองและรับประกันว่าข้อมูลการลงทะเบียนทั้งหมดที่ท่านให้นั้นถูกต้อง
              เชื่อถือได้ ครบถ้วนและถูกต้องตามกฎหมาย
              และท่านรับรองว่าท่านจะรักษาความถูกต้องของข้อมูลดังกล่าวและปรับปรุงข้อมูลให้ทันสมัยเมื่อจำเป็น
            </p>
            <p>
              ท่านมีหน้าที่รับผิดชอบแต่เพียงผู้เดียวต่อการกระทำทั้งหมดที่เกิดขึ้นในบัญชีของท่าน
              สำหรับการใช้งานเว็บไซต์ทั้งหมดโดยท่านหรือใครก็ตามที่ใช้ ID ของท่าน
              ทั้งนี้เพื่อป้องกันการใช้ ID
              ของท่านซึ่งไม่ได้รับอนุญาตและเพื่อเป็นการรักษาความลับและความปลอดภัยของ
              ID ท่าน ท่านตกลงที่จะไม่ใช้บัญชีที่ลงทะเบียนและ / หรือ ID
              ของคนอื่นไม่ว่าเวลาใดหรือเปิดเผยรหัสผ่านของท่านต่อบุคคลที่สาม
              โปรดแจ้งให้เราทราบทันทีหากท่านเชื่อว่ามีการละเมิดความปลอดภัยเช่นการเปิดเผยข้อมูล
              การโจรกรรมหรือการใช้ ID ของท่านโดยไม่ได้รับอนุญาต
            </p>
            <p>
              เมื่อท่านสร้างบัญชีบนเว็บไซต์แล้ว
              ท่านตกลงที่จะรับการสื่อสารบางประการที่เกี่ยวข้องกับการใช้งานเว็บไซต์
              รวมถึงท่านจะได้รับอีเมล์การตลาดของเราด้วย เช่นจดหมายข่าว
              สำหรับข้อมูลเพิ่มเติมโปรดศึกษานโยบายความเป็นส่วนตัวของเราได้ที่{' '}
              <a
                href='https://datawow.co.th/policy'
                target='_blank'
                rel='nofollow noopener noreferrer'
              >
                https://www.datawow.co.th/policy
              </a>
            </p>
            <p>
              ในการให้ข้อมูลของท่านและการยอมรับข้อตกลงการใช้งานของเรา
              ท่านยินยอมให้ Data Wow เรียกเก็บ
              ใช้และเปิดเผยข้อมูลส่วนบุคคลของท่านให้แก่บุลคลอื่น เช่น ลูกจ้าง
              ผู้ให้บริการ ผู้จำหน่ายของ Data Wow และตกลงยอมรับซึ่งระบบต่างๆ
              เพื่อวัตถุประสงค์เกี่ยวกับการสมัครใช้งานของท่านและการลงทะเบียนเป็นสมาชิกของท่าน
              และเพื่อยืนยันว่าท่านมีสิทธิ์ได้รับส่วนลด สิทธิพิเศษหรือผลประโยชน์
              หรือเพื่อวัตถุประสงค์อื่นๆ ที่เกี่ยวข้อง
              เพื่อทำการวิจัยและวิเคราะห์การตลาด
              สำหรับการตลาดโดยตรงผ่านข้อความเสียง ข้อความ
              อีเมล์จดหมายโดยตรงและข้อความทางโทรสาร
              สำหรับวัตถุประสงค์ในการชำระเงินและ / หรือการควบคุมเครดิต
              เพื่อแจ้งให้ท่านทราบถึงการเปลี่ยนแปลงนโยบายหรือบริการของเราที่อาจส่งผลกระทบต่อท่าน
              เพื่อตอบข้อสงสัยและข้อเสนอแนะ เพื่อระบุตัวตนและการเข้าถึงเว็บไซต์
              การรักษาไว้และปรับปรุงรายละเอียดการเป็นสมาชิกของท่าน
              และเพื่อแจ้งให้ท่านทราบถึงพัฒนาการใหม่ การบริการ โปรโมชั่นของ Data
              Wow และบุคคลที่สามอื่น ๆ ที่เกี่ยวข้องกับเรา
            </p>

            <h3>6. ข้อปฏิบัติของผู้ใช้ </h3>
            <p>
              ท่านมีหน้าที่รับผิดชอบต่อข้อความ ภาพถ่าย วิดีโอ ภาพ
              และข้อมูลการสื่อสารในรูปแบบอื่น ๆ (เรียกรวมกันว่า “ข้อความ”)
              ที่ท่านถ่ายทอดหรือส่งผ่านหรือเชื่อมต่อที่เกี่ยวข้องกับการใช้งานเว็บไซต์
              โดยข้อความดังกล่าวรวมถึง ความเห็น การให้คะแนน
              และข้อมูลที่ท่านแสดงต่อสาธารณะในหน้าโปรไฟล์ของท่าน
              ท่านยอมรับความเสี่ยงทั้งหมดที่เกี่ยวข้องกับข้อความของท่านรวมถึงความเชื่อถือใดๆของบุคคลที่สามในความถูกต้องและความน่าเชื่อถือ
              ท่านรับรองว่าข้อความของท่านไม่ละเมิดทรัพย์สินทางปัญญาของบุคคลอื่น
              และท่านเป็นเจ้าของหรือมีสิทธิที่ในการใช้ตามกฎหมาย
              และได้รับอนุญาตการใช้งานข้อความของท่าน
              ท่านควรละเว้นการกระทำการใดๆให้ข้อความมีข้อความหมิ่นประมาท เป็นเท็จ
              ทำให้เข้าใจผิด ละเมิด รบกวน ดูหมิ่น ดูถูกเหยียดหยาม ข่มขู่
              อนาจารหรือผิดกฎหมาย ซึ่งท่านมีหน้าที่ต้องรับผิดชอบด้วยตนเอง
            </p>
            <p>
              นอกจากนี้ตามเงื่อนไขการส่งข้อความใดๆ ไปยังเว็บไซต์ ท่านยอมรับว่า:
              <br />
              ท่านอนุญาตให้ Data Wow โดยปลอดค่าสิทธิ อย่างต่อเนื่อง
              เพิกถอนไม่ได้ เผยแผ่ทั่วโลกไม่จำกัด ไม่จำกัดเฉพาะแต่ผู้เดียว
              โอนสิทธิได้ และอนุญาตให้ใช้สิทธิช่วง ในการอนุญาตให้ใช้ ทำซ้ำ
              ทำสำเนา ดัดแปลง แก้ไข รวม แจกจ่าย แสดงต่อสาธารณชน
              สร้างผลงานดัดแปลงแบบ รวบรวมข้อความดังกล่าวให้กลายเป็นงานอื่น
            </p>
            <ul>
              <li>
                ท่านอนุญาตให้ Data Wow
                มีสิทธิทั้งหมดที่จำเป็นในการเผยแพร่หรือละเว้นจากการเผยแพร่ชื่อและที่อยู่ของท่านในการเชื่อมต่อกับข้อความของท่าน
                การอนุญาตช่วงผ่านเนื้อหาแบบ Multiple tires
                และรับทราบว่าการอนุญาตนี้ท่านไม่สามารถยกเลิกสัญญาได้เมื่อข้อความของท่านได้ถูกส่งไปยังเว็บไซต์
              </li>
              <li>
                ท่านอนุญาตให้ Data Wow มีสิทธิทั้งหมดที่จำเป็นในการห้าม
                การรวบรวม การเปิดเผย การคัดลอก การทำซ้ำ การจำลอง การทำสำเนา
                การแจกจ่าย
                หรือการใช้ประโยชน์ตามลำดับจากข้อความของท่านโดยบุคคลอื่นๆ
              </li>
              <li>
                ท่านรับรองและรับประกันว่าแต่ละบุคคลที่มีการระบุหรือแสดงในข้อความของท่าน
                หากมี (และหากเป็นผู้เยาว์ บิดามารดา หรือผู้ปกครองของผู้เยาว์)
                ได้ให้ความยินยอมในการใช้ข้อความที่สอดคล้องกับข้อกำหนดการใช้เหล่านี้แล้ว
              </li>
              <li>
                ท่านต้องรับผิดชอบแต่เพียงผู้เดียวต่อความเห็นและการให้คะแนนของท่าน
              </li>
              <li>
                Data Wow จะกลั่นกรองและตรวจสอบข้อความทั้งหมดที่โพสต์ลงบนเว็บไซต์
              </li>
              <li>
                Data Wow
                อาจใช้ดุลยพินิจแต่เพียงผู้เดียวในการเลือกที่จะลบหรือไม่ลบบทวิจารณ์และการให้คะแนนเมื่อมีการเผยแพร่
              </li>
              <li>
                ความเห็นและการให้คะแนนสินค้าทั้งหมดที่ท่านให้คะแนนจะต้องถูกต้อง
                เที่ยงตรง เป็นความจริงและสมบูรณ์ทุกประการ
              </li>
              <li>
                ท่านจะไม่ได้รับแบบค่าชดเชยใดๆ จากการโพสต์ความเห็นและการให้คะแนน
              </li>
              <li>ท่านจะส่งคำวิจารณ์อย่างละเอียดและรอบคอบ</li>
              <li>
                ท่านจะไม่ส่งความเห็นโดยใช้ชื่อผู้ใช้รายอื่นหรือความเห็นของผู้ใช้รายอื่น
              </li>
              <li>
                ท่านจะไม่ส่งความเห็นแบบ ไฮเปอร์ลิงก์
                หรือความเห็นและการให้คะแนนที่ท่านให้ไว้จะไม่เป็นการแสดงความเห็นเกี่ยวกับ
                Data Wow เจ้าหน้าที่ ผู้จัดการ เจ้าของตัวแทน
                ผู้ได้รับมอบหมายหรือผู้ใช้รายอื่น
              </li>
            </ul>
            <h3>7. ความถูกต้องและสมบูรณ์ของข้อมูล</h3>
            <p>
              ในบางโอกาส ข้อมูลบนเว็บไซต์อาจมีข้อผิดพลาด เช่น มีการสะกดผิด
              ความไม่ถูกต้องของข้อมูล
              หรือการละเว้นในบางจุดที่อาจมีความเกี่ยวข้องกับรายการส่งเสริมการขายและข้อเสนอ
              เราขอสงวนสิทธิ์ในการแก้ไขข้อผิดพลาด ความไม่ถูกต้องหรือการละเว้นใด
              ๆ และในการการเปลี่ยนแปลง
              ทำให้ข้อมูลเป็นปัจจุบันหรือยกเลิกคำสั่งซื้อหากข้อมูลใด ๆ
              บนเว็บไซต์หรือบริการที่เกี่ยวข้องมีความไม่ถูกต้องเมื่อใดก็ได้โดยไม่จำเป็นต้องแจ้งให้ท่านทราบล่วงหน้า
              (รวมถึงหลังจากที่ท่านส่งคำสั่งซื้อแล้ว)
              เราไม่มีหน้าที่ในการทำให้ข้อมูลเป็นปัจจุบัน แก้ไข
              หรือชี้แจงในข้อมูลบนเว็บไซต์ ซึ่งรวมไปถึงแต่ไม่จำกัดไว้เพียง
              ข้อมูลราคา เว้นแต่ว่ากฎหมายได้มีการกำหนดให้ต้องกระทำ
              จะไม่มีการกำหนดวันที่หรือวันที่มีเปลี่ยนแปลงบนเว็บไซต์
              หรือบริการอื่น ๆ ที่เกี่ยวข้องเมื่อมีการแก้ไขหรือทำให้เป็นปัจจุบัน
            </p>

            <h3>8. ข้อจำกัดความรับผิด</h3>
            <p>
              ไม่ว่าในกรณีใดๆ Data Wow บริษัทแม่
              บริษัทย่อยหรือบริษัทในเครือหรือเจ้าหน้าที่ กรรมการ พนักงานตัวแทน
              ผู้สืบทอด บริษัทย่อย หน่วยงาน ผู้จัดจำหน่าย ซัพพลายเออร์
              บริษัทในเครือหรือบุคคลที่สามที่ให้ข้อมูลบนเว็บไซต์นี้
              ไม่มีหน้าที่รับผิดชอบต่อผู้ใช้งานเว็บไซต์หรือบุคคลอื่นหรือนิติบุคคลอื่นใด
              สำหรับความเสียหายโดยตรง โดยอ้อม กรณีพิเศษ อันเป็นอุบัติเหตุ
              ในเชิงลงโทษ มีผลสืบเนื่องหรือค่าเสียหายเชิงลงโทษเป็นแบบอย่าง
              (รวมถึงแต่ไม่จำกัดเฉพาะความเสียหายจากการสูญเสียกำไร
              การสูญเสียข้อมูลหรือการสูญเสียจากการใช้งาน)
              ที่เกิดขึ้นจากการใช้งานหรือไม่สามารถใช้งานเว็บไซต์หรือข้อมูลใดๆ
              ที่มีอยู่ หรือจัดเก็บ หรือรักษาโดย Data Wow
              โดยไม่ว่าจะเป็นการรับประกัน การให้สัญญา การละเมิด หรือกรณีอื่นๆ
              แม้ว่า Data Wow
              จะทราบหรือควรทราบถึงความเป็นไปได้ของความเสียหายหรือความสูญเสียดังกล่าว
              โดยไม่ได้จำกัดตามที่กล่าวมาข้างต้น และไม่ว่าในกรณีใดๆก็ตาม Data
              Wow บริษัทแม่ บริษัทย่อยหรือบริษัทในเครือหรือเจ้าหน้าที่ กรรมการ
              พนักงาน ตัวแทน ผู้สืบทอด บริษัทย่อย หน่วยงาน ผู้จัดจำหน่าย
              ซัพพลายเออร์ บริษัทในเครือหรือบุคคลที่สามที่ให้ข้อมูลในเว็บไซต์นี้
              จะไม่รับผิดชอบใดๆต่อความเสียหายหรือความสูญเสีย
              ที่เกิดขึ้นอันเกี่ยวกับกับการสูญเสียข้อความหรือข้อมูลใด ๆ
              ในบัญชีของท่านหรือที่ถูกจัดเก็บไว้โดยหรือในนามของ Data Wow
            </p>
            <p>
              ท่านรับทราบว่าวรรคก่อนหน้านี้มีผลบังคับใช้กับข้อความและบริการทั้งหมดในเว็บไซต์
              เนื่องจากบางประเทศไม่อนุญาตให้มีข้อจำกัดในการรับประกันโดยนัย
              หรือการยกเว้นหรือการจำกัดค่าเสียหายบางอย่าง
              ซึ่งในประเทศดังกล่าวนั้น
              ข้อจำกัดความรับผิดหรือข้อยกเว้นข้างต้นบางอย่างหรือทั้งหมดอาจไม่มีผลบังคับใช้
              และความรับผิดจะถูกจำกัดตามขอบเขตสูงสุดตามกฎหมายในประเทศนั้นๆใช้บังคับ
            </p>
            <p>
              ท่านยอมรับว่าการใช้งานเว็บไซต์หรือบริการที่ทางเราได้จัดขึ้น
              เป็นการที่ท่านยอมรับความเสี่ยงเองแต่เพียงผู้เดียว
              ท่านยอมรับว่าบริการดังกล่าวจัดเตรียมมีให้ในรูปแบบ "ตามที่เป็นอยู่"
              และ "ตามที่มีอยู่" เราขอปฏิเสธการรับประกันใด ๆ โดยชัดแจ้ง
              ไม่ว่าโดยชัดแจ้งหรือโดยนัย ซึ่งรวมถึงแต่ไม่จำกัดเพียง
              การรับประกันโดยนัยเกี่ยวกับความสามารถทางการค้า
              ความเหมาะสมสำหรับวัตถุประสงค์เฉพาะ
              และการไม่เกิดเหตุละเมิดการใช้งาน
              เราไม่รับประกันว่าบริการจะตรงตามความต้องการของท่านหรือบริการจะไม่ขัดข้อง
              ใช้ได้ตลอดเวลา ปลอดภัย หรือปราศจากข้อผิดพลาด และเราไม่รับประกันใด
              ๆ
              เกี่ยวกับผลลัพธ์ที่อาจได้รับจากการใช้บริการและการเข้าร่วมกิจกรรมของท่านหรือความถูกต้องหรือความน่าเชื่อถือของข้อมูลใด
              ๆ
              ที่ได้รับผ่านบริการหรือข้อบกพร่องที่เกิดขึ้นในบริการจะได้รับการแก้ไข
              ท่านเข้าใจและยอมรับว่าเนื้อหาและ / หรือข้อมูลใด ๆ
              ที่ได้ดาวน์โหลดหรือได้รับจากการใช้บริการจะได้กระทำขึ้นและอยู่กับดุลยพินิจและความเสี่ยงของท่านเองและท่านจะต้องรับผิดชอบแต่เพียงผู้เดียวสำหรับความเสียหายที่เกิดขึ้นกับระบบคอมพิวเตอร์ของท่านหรือการสูญเสียข้อมูลอันเป็นผลมาจาก
              ดาวน์โหลดสิ่งนั้นและ / หรือข้อมูลดังกล่าว
              เราไม่รับประกันสินค้าหรือบริการใด ๆ
              ที่ซื้อหรือได้รับผ่านบริการหรือธุรกรรมใด ๆ ที่ทำผ่านบริการ
              คำปรึกษาทางกฎหมายหรือข้อมูลที่กระทำโดยวาจาหรือลายลักษณ์อักษรที่ท่านได้รับจากเราหรือผ่านการบริการของเราจะไม่เป็นการรับรองในสิ่งที่ไม่ได้มีการระบุไว้ภายใต้สัญญานี้
            </p>
            <h3>9. การชดใช้ความเสียหาย</h3>
            <p>
              ท่านตกลงที่จะชดเชย ปกป้อง และชดใช้ค่าเสียหายให้ Data Wow กรรมการ
              เจ้าหน้าที่ ลูกจ้าง ที่ปรึกษา ตัวแทนและบริษัทในเครือ
              จากการเรียกร้องใดๆ ความรับผิดค่าเสียหายและ / หรือค่าใช้จ่าย
              ที่บุคคลที่สามเรียกร้อง
              (รวมถึงแต่ไม่จำกัดเพียงค่าธรรมเนียมทางกฎหมาย)
              ที่เกิดขึ้นจากการใช้งานเว็บไซต์นี้หรือที่ท่านได้ละเมิดข้อกำหนดการใช้งาน
            </p>

            <h3>10. การเปลี่ยนแปลง</h3>
            <p>
              Data Wow
              มีสิทธิใช้ดุลยพินิจแต่เพียงผู้เดียวได้ตลอดเวลาโดยไม่ต้องแจ้งให้ทราบล่วงหน้าในการแก้ไข
              ลบหรือเปลี่ยนแปลงการบริการและ/หรือหน้าใด ๆ ของเว็บไซต์นี้
            </p>

            <h3>
              11. เว็บไซต์นี้อาจมีการเชื่อมต่อ (Link) ไปยังเว็บไซต์อื่น ๆ
              บนอินเทอร์เน็ต
            </h3>
            <p>
              หากท่านได้เลือกที่จะเปิดใช้ เข้าถึง หรือใช้บริการของบุคคลที่สาม
              ขอให้ท่านคำนึงเอาไว้ว่าการเข้าใช้หรือใช้งานบริการดังกล่าวได้ถูกกำหนดโดยเงื่อนไขและข้อกำหนดของการให้บริการอื่นนั้นแต่เพียงผู้เดียว
              และทางเราจะไม่ขอรับรอง มีหน้าที่หรือรับผิดชอบ
              และไม่ขอให้คำรับรองสำหรับบริการอื่นดังกล่าว
              ซึ่งรวมไปถึงแต่ไม่จำกัดไว้เพียงเนื้อหาหรือวิธีที่บุคคลเหล่านั้นจัดการกับข้อมูล
              (รวมถึงข้อมูลส่วนบุคคลของท่าน)
              หรือการติดต่อกันระหว่างท่านและผู้ให้บริการอื่นนั้น
              ท่านขอสละสิทธิ์โดยไม่เปลี่ยนแปลงว่าจะไม่เรียกร้องจาก Data Wow
              ในเรื่องที่เกี่ยวข้องกับการบริการอื่นดังกล่าว Data Wow
              จะไม่รับผิดชอบต่อความเสียหายหรือความสูญเสียที่ได้เกิดขึ้นหรือถูกกล่าวหาว่าได้เกิดขึ้นโดยหรือเกี่ยวข้องกับการที่ท่านเลือกใช้
              เข้าถึง หรือใช้บริการอื่นดังกล่าว
              หรือจากการที่ท่านได้ไว้วางใจในการปฏิบัติต่อความเป็นส่วนตัว
              ความปลอดภัยของการประมวลผลข้อมูล หรือนโยบายอื่นใดของบริการดังกล่าว
              ท่านอาจจำเป็นจะต้องสมัครหรือลงชื่อเข้าใช้การบริการอื่นดังกล่าวกับเว็บไซต์อื่นนั้น
              ๆ การที่ท่านได้เลือกที่จะเปิดใช้การบริการอื่นดังกล่าวนั้น
              ท่านได้อนุญาต Data Wow
              โดยชัดแจ้งในการเปิดเผยข้อมูลของท่านเท่าที่จำเป็นในการช่วยให้ใช้งานหรือเปิดการใช้งานบริการอื่นดังกล่าว
            </p>
            <p>
              แม้ว่าเว็บไซต์นี้อาจมีการเชื่อมต่อไปยังเว็บไซต์อื่น
              เราไม่ได้อนุมัติโดยเป็นนัยยะ ร่วมกัน สนับสนุน ช่วยเหลือ
              หรือเป็นเครือเดียวกันกับเว็บไซต์อื่นที่ได้มีการเชื่อมต่อไม่ว่าจะทางตรงหรืออ้อม
              เว้นเสียแต่ได้กำหนดไว้เป็นการเฉพาะไว้ในที่นี้
              เราไม่มีหน้าที่ในการตรวจสอบหรือประเมิน
              และเราไม่ขอรับรองในข้อเสนอของธุรกิจหรือบุคคลใด ๆ
              หรือเนื้อหาในเว็บไซต์นั้น เราไม่รับผิดชอบหรือรับผิดใด ๆ
              ต่อการกระทำ ผลิตภัณฑ์ บริการและเนื้อหาของบุคคลอื่น ๆ ดังนั้น
              ท่านควรตรวจสอบการชี้แจงทางกฎหมายและเงื่อนไขในการใช้งานของเว็บไซต์ใด
              ๆ ที่ท่านได้เชื่อมต่อผ่านเว็บไซต์นี้
              ท่านเป็นผู้รับความเสี่ยงที่อาจเกิดขึ้นทั้งหมดในการเชื่อมต่อไปยังเว็บไซต์อื่น
              ๆ
            </p>

            <h3>12. การไม่มีตัวแทน</h3>
            <p>
              ข้อกำหนดการใช้งานนี้
              ไม่มีวัตถุประสงค์เกี่ยวกับหรือมีลักษณะในการแต่งตั้ง ตัวแทน
              หุ้นส่วน กิจการร่วมค้า นายจ้างลูกจ้าง หรือ แฟรนไชส์
              อีกทั้งไม่เกี่ยวข้อง หรือมีอยู่ซึ่งหรือทำให้เกิดลักษณะ ตัวแทน
              หุ้นส่วน การร่วมทุน นายจ้างลูกจ้าง หรือแฟรนไชส์ ระหว่าง Data Wow
              กับผู้ใช้หรือผู้ประกอบการค้า
            </p>
            <h3>13. การบอกกล่าว</h3>
            <p>
              เว้นแต่ที่ระบุไว้อย่างชัดเจนเป็นอย่างอื่น
              การส่งหนังสือทางกฎหมายใดๆ จะต้องจัดส่งไปยังบริษัท เดต้า ว้าว จำกัด
              ทางไปรษณีย์ลงทะเบียน ไปยังเลขที่ 1778 อาคารซัมเมอร์ฮับ ชั้น 6
              ถนนสุขุมวิท แขวงพระโขนง เขตคลองเตย กรุเทพมหานคร 10110 (จังส่ง Data
              Wow)
              หรือที่อยู่อีเมล์ที่ท่านให้ไว้กับเราระหว่างขั้นตอนการลงทะเบียน
              (ในกรณีจัดส่งท่าน) จะถือว่าหนังสือดังกล่าวได้ถูกจัดส่งเมื่อครบ 24
              ชั่วโมงหลังจากการส่งอีเมล์
              เว้นเสียแต่ว่าฝ่ายที่ส่งหนังสือดังกล่าวจะได้รับแจ้งว่าที่อยู่อีเมล์นั้นไม่ถูกต้อง
            </p>

            <h3>14. การแยกข้อสัญญาส่วนที่เป็นโมฆะออกจากส่วนที่ไม่เป็นโมฆะ</h3>
            <p>
              สิทธิและข้อจำกัดทั้งหมดที่มีอยู่ในข้อตกลงนี้อาจถูกใช้
              จะมีผลบังคับใช้และมีผลผูกพันเฉพาะในขอบเขตที่ข้อจำกัดนั้นไม่ฝ่าฝืนกฎหมายที่เกี่ยวข้องใด
              ๆ
              และมีเจตนาที่จำกัดอยู่ในขอบเขตที่จำเป็นเพื่อที่จะไม่ทำให้สัญญาฉบับนี้ผิดกฎหมาย
              ไม่เป็นผล หรือไม่สามารถบังคับใช้ได้
              หากข้อกำหนดหรือส่วนใดส่วนหนึ่งของข้อกำหนดใด ๆ
              ของสัญญาฉบับนี้ผิดกฎหมาย ไม่เป็นผล
              หรือไม่สามารถบังคับใช้ได้โดยศาลที่มีอำนาจ
              คู่สัญญาตกลงว่าบทบัญญัติหรือส่วนที่เหลืออยู่จะยังเป็นข้อตกลงที่ยังคงมีผลบังคับใช้ได้ต่อไป
            </p>
            <h3>15. การโอนสิทธิ</h3>
            <p>
              ท่านจะต้องไม่ทำการโอน ขายต่อ อนุญาตช่วง
              หรือทำการโอนย้ายหรือมอบหมายในสิทธิหรือหน้าที่ใด ๆ
              ของท่านที่ได้กำหนดไว้ไม่ว่าจะทั้งหมดหรือบางส่วนโดยไม่ได้รับความยินยอมจากพวกเรา
              โดยที่ความยินยอมของพวกเรานั้นจะขึ้นอยู่กับดุลพินิจของเราแต่เพียงผู้เดียวโดยและไม่มีเงื่อนไขอื่นใด
              การโอนสิทธิหรือโอนย้ายใด ๆ ดังกล่าวจะต้องเป็นโมฆะและไม่มีผล
              ทั้งนี้ เรามีอิสระที่จะโอนสิทธิ์หรือภาระผูกพันใด ๆ
              ไม่ว่าทั้งหมดหรือบางส่วนให้กับบุคคลที่สามซึ่งเป็นส่วนหนึ่งของการขายทรัพย์สินหรือหุ้นทั้งหมดหรือในส่วนสำคัญทั้งหมดหรือเป็นส่วนหนึ่งของการควบรวมกิจการ
            </p>

            <h3>16. การเปลี่ยนแปลงและการแก้ไข</h3>
            <p>
              เราขอสงวนสิทธิในการแก้ไขสัญญาฉบับนี้หรือนโยบายที่เกี่ยวข้องกับเว็บไซต์
              หรือบริการในเวลาใดก็ได้
              โดยจะมีผลทันทีเมื่อได้ทำการเผยแพร่สัญญาฉบับล่าสุดลงบนเว็บไซต์
              โดยเราจะทำการระบุวันที่มีการแก้ไขลงไว้ข้างใต้ของสัญญา
              การเข้าใช้งานเว็บไซต์
              หลังจากที่มีการแก้ไขดังกล่าวจะถือเป็นการที่ท่านได้ยินยอมในการแก้ไขนั้น
              ๆ
            </p>
            <h3>17. การยอมรับในข้อตกลง</h3>
            <p>
              ท่านยอมรับและรับทราบว่าท่านได้อ่านสัญญาฉบับนี้และยินยอมในข้อตกลงและเงื่อนไขทั้งหมดดังกล่าว
              ในการใช้งานเว็บไซต์หรือบริการย่อมถือว่าท่านได้ยินยอมที่จะผูกพันกับสัญญาฉบับนี้
              หากท่านไม่ยินยอมในข้อตกลงของสัญญาฉบับนี้
              ท่านจะไม่มีสิทธิในการใช้งานหรือเข้าถึงเว็บไซต์หรือบริการดังกล่าว
            </p>
            <h3>18. กฎหมายที่ใช้บังคับและเขตอำนาจศาล</h3>
            <p>
              ในการเยี่ยมชมเว็บไซต์นี้ ท่านได้ตกลงให้กฎหมายของประเทศไทย
              โดยไม่คำนึงถึงหลักแห่งการขัดกันแห่งกฎหมาย
              ให้มีผลบังคับใช้กับข้อกำหนดการใช้งานและข้อพิพาทใด ๆ
              ที่อาจเกิดขึ้นระหว่างท่านและ Data Wow
            </p>
            <p>
              ศาลประเทศไทยมีเขตอำนาจพิจารณาในการดำเนินการทางกฎหมายใดๆ
              หรือการดำเนินคดีกับ Data Wow ที่เกิดขึ้น
              ในส่วนหรือเกี่ยวข้องกับข้อพิพาทใด ๆ จากข้อกำหนดการใช้งานนี้
              รวมถึงข้อพิพาทระหว่างผู้ใช้เว็บไซต์นี้
            </p>

            <p>เอกสารฉบับนี้ปรับปรุงล่าสุดเมื่อวันที่ 20 กันยายน พ.ศ. 2566</p>
          </div>
        </div>
      </div>

      <LazyLoad>
        <GetStarted />
      </LazyLoad>
    </React.Fragment>
  )
}

TermsOfUse.getLayout = function getLayout(page) {
  return <MainLayout>{page}</MainLayout>
}
